export default {
  GET_ALL: `#graphql
  query getMethods($search: String, $searchBy: String, $search1: String, $searchBy1: String, $limit: Int, $page: Int, $sort: String, $order: String, $init: Date, $final: Date) {
    getMethods(search: $search, searchBy: $searchBy, search1: $search1, searchBy1: $searchBy1, limit: $limit, page: $page, sort: $sort, order: $order, init:  $init, final: $final)
    { 
      docs {
        method,
        activeBrands,
        activeMethod,
        order,
        cost,
        image,
        folder,
        type
      },
      totalDocs,
      limit,
      hasPrevPage,
      hasNextPage,
      page,
      totalPages,
      prevPage,
      nextPage,
      pagingCounter
    }            
  }`,

  GET_HISTORY: `#graphql
  query getMethodsHistory($search: String, $searchBy: String, $search1: String, $searchBy1: String, $limit: Int, $page: Int, $sort: String, $order: String, $init: Date, $final: Date) {
    getMethodsHistory(search: $search, searchBy: $searchBy, search1: $search1, searchBy1: $searchBy1, limit: $limit, page: $page, sort: $sort, order: $order, init:  $init, final: $final)
    { 
      docs {
        _id,
        version,
        method,
        activeBrands,
        activeMethod,
        order,
        cost,
        image,
        folder,
        type,
        transaction,
        createdAt,
        createdBy,
        updatedBy
      },
      totalDocs,
      limit,
      hasPrevPage,
      hasNextPage,
      page,
      totalPages,
      prevPage,
      nextPage,
      pagingCounter
    }            
  }`,

  NEW: `#graphql
  mutation NewMethod($method: MethodInput!) {
    newMethod(input: $method)
    {
      method,
      activeBrands,
      activeMethod,
      order,
      cost,
      image,
      folder,
      type
    }            
  }`,

  UPDATE: `#graphql
  mutation UpdateMethod($method: String!, $methodUpdate: MethodUpdateInput!) {
    updateMethod(method:$method, methodUpdate: $methodUpdate)
    {
      method
    }            
  }`,

  DELETE: `#graphql
  mutation DeleteMethod($method: String!) {
    deleteMethod(method:$method)
    {
      method
    }            
  }`
}



// WEBPACK FOOTER //
// ./src/graphql/method.js